module.exports = __webpack_public_path__ + "pg.svg?9806ef36eddcfcaa19e5f2ddc501d77c";